import script from "./TeamMemberForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./TeamMemberForm.vue?vue&type=script&lang=ts&setup=true"

import "./TeamMemberForm.vue?vue&type=style&index=0&id=7e49e2f6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e49e2f6"]])

export default __exports__